import { BrowserRouter, Routes, Route, Outlet, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import SmoothScroll from "@/components/motion/SmoothScroll";
import Navbar from "@/components/layout/Navbar";
import Footer from "@/components/layout/Footer";
import { AuthProvider } from "@/context/AuthContext";
import AuthCallback from "@/components/auth/AuthCallback";
import ProtectedRoute from "@/components/auth/ProtectedRoute";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Events from "@/pages/Events";
import Prayer from "@/pages/Prayer";
import Contact from "@/pages/Contact";
import Give from "@/pages/Give";
import Blog from "@/pages/Blog";
import BlogPost from "@/pages/BlogPost";
import Book from "@/pages/Book";
import Gallery from "@/pages/Gallery";
import Archives from "@/pages/Archives";
import AdminLogin from "@/pages/admin/Login";
import AdminDashboard from "@/pages/admin/Dashboard";

function PublicLayout() {
  return (
    <>
      <Navbar />
      <main className="relative z-10">
        <Outlet />
      </main>
      <Footer />
    </>
  );
}

function AppRouter() {
  const location = useLocation();
  // Catch OAuth callback on any route (session_id arrives in URL fragment)
  if (location.hash?.includes("session_id=")) return <AuthCallback />;

  return (
    <Routes>
      {/* Admin (no nav/footer) */}
      <Route path="/admin/login" element={<AdminLogin />} />
      <Route path="/admin/callback" element={<AuthCallback />} />
      <Route
        path="/admin"
        element={
          <ProtectedRoute requireAdmin>
            <AdminDashboard />
          </ProtectedRoute>
        }
      />

      {/* Public site */}
      <Route element={<PublicLayout />}>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/events" element={<Events />} />
        <Route path="/prayer" element={<Prayer />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/give" element={<Give />} />
        <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<BlogPost />} />
        <Route path="/book" element={<Book />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/archives" element={<Archives />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App grain bg-black min-h-screen">
      <BrowserRouter>
        <AuthProvider>
          <SmoothScroll>
            <AppRouter />
          </SmoothScroll>
        </AuthProvider>
      </BrowserRouter>
      <Toaster
        position="bottom-right"
        theme="dark"
        toastOptions={{ style: { background: "#0A0A0A", border: "1px solid #E10600", color: "#fff", borderRadius: 0 } }}
      />
    </div>
  );
}

export default App;
